/**
 * Bungie's icon and screenshot CDN is public — no API key, no OAuth. We link
 * directly rather than proxying; these are the same URLs the official site
 * serves, and using them is how every community tool displays item art.
 */
const BUNGIE_ROOT = "https://www.bungie.net";

/** Absolute URL for a manifest asset path, or undefined if there is none. */
export function assetUrl(path: string | undefined): string | undefined {
  if (!path) return undefined;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${BUNGIE_ROOT}${path.startsWith("/") ? "" : "/"}${path}`;
}

/* Element identity comes from the manifest's own damage-type icons
   (`damageTypeIcon` on each weapon), not a hardcoded colour table — those
   symbols are what players actually recognise, and a new subclass element ships
   with the manifest rather than needing a code change. */

/** Ammo type enum from the manifest's equippingBlock. */
export function ammoLabel(ammoType: number | undefined): string | undefined {
  switch (ammoType) {
    case 1:
      return "Primary";
    case 2:
      return "Special";
    case 3:
      return "Heavy";
    default:
      return undefined;
  }
}

/**
 * Weapon stats in the order the game lists them.
 *
 * This is an allow-list, not just an ordering: the manifest also carries
 * internal stats (Attack, Power, Ammo Generation) that the in-game inspect
 * screen does not show, and surfacing them would be noise the reference
 * captures do not have.
 */
export const STAT_DISPLAY_ORDER: readonly number[] = [
  4043523819, // Impact
  1240592695, // Range
  155624089, // Stability
  943549884, // Handling
  4188031367, // Reload Speed
  1345609583, // Aim Assistance
  3555269338, // Zoom
  2714457168, // Airborne Effectiveness
  3871231066, // Magazine
  4284893193, // Rounds Per Minute
  2715839340, // Recoil Direction
];

/** Stats shown as a plain number rather than a bar, matching the game. */
export const NUMERIC_STATS = new Set([4284893193, 3871231066, 2715839340]);
